import React, {FC, useCallback, useState} from 'react';

import {useInitialEffect} from '../../../../../../libs/shared/helpers/src/react/hooks/useEffectHelpers';
import {AsyncStatusesEnum} from '../../../../../../libs/shared/helpers/src/types/asyncStatuses';
import {DropdownProps} from '../../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {useUnmountCancelToken} from '../../../../../../srcCommon/helpers/hookHelpers';
import {MessageModel} from '../../../../../models/api/messageModel';
import {ApiSeens, SeenModel} from '../../../../../models/api/seenModel';
import {fetchApiAsync} from '../../../../../services/http/http';
import {SeenDropdown} from './seenDropdown';

/*
 * Props.
 */

interface SeenDropdownContainerProps extends DropdownProps {
  message: MessageModel;
}

/*
 * Component.
 */

export const SeenDropdownContainer: FC<SeenDropdownContainerProps> = (props) => {
  const {message} = props;
  const [status, setStatus] = useState<AsyncStatusesEnum>(AsyncStatusesEnum.LOADING);
  const [seens, setSeens] = useState<ReadonlyArray<SeenModel>>([]);
  const unmountToken = useUnmountCancelToken();

  const fetchSeens = useCallback(async () => {
    try {
      const path = `${message.url}/seens`;
      const serverSeens = await fetchApiAsync(ApiSeens, path, {cancelToken: unmountToken});

      setStatus(AsyncStatusesEnum.LOADED);
      setSeens(serverSeens.seens);
    } catch (error) {
      setStatus(AsyncStatusesEnum.FAILED);
    }
  }, [message.url, unmountToken]);

  useInitialEffect(() => {
    fetchSeens();
  });

  return (
    <SeenDropdown {...props} message={message} seens={seens} status={status} onRetryClick={fetchSeens} />
  );
};
